exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".battery {\n  width: 100%;\n  background: #fff;\n}\n.battery .battery-tit {\n  width: 70%;\n  line-height: 60px;\n  padding: 0 50px 0 30px;\n  overflow: hidden;\n}\n.battery .battery-tit h3 {\n  font-weight: normal;\n  font-size: 20px;\n  float: left;\n  margin-right: 20px;\n}\n.battery .battery-tit p {\n  font-size: 15px;\n  float: left;\n  margin-right: 50px;\n}\n.battery .battery-tit .battery-refresh {\n  float: left;\n}\n.battery .battery-status {\n  padding-left: 70px;\n  width: 70%;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n.battery .battery-status div {\n  width: 33%;\n  line-height: 20px;\n  float: left;\n  font-size: 13px;\n}\n.battery .battery-xxk {\n  padding: 0 30px 0 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/sbDevice/batteryInfo/index.less
// module id = 1552
// module chunks = 0